"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProfileServiceBase = exports.useProfileService = void 0;
var useProfileService_hook_1 = require("./useProfileService.hook");
Object.defineProperty(exports, "useProfileService", { enumerable: true, get: function () { return useProfileService_hook_1.useProfileService; } });
var useProfileServiceBase_hook_1 = require("./useProfileServiceBase.hook");
Object.defineProperty(exports, "useProfileServiceBase", { enumerable: true, get: function () { return useProfileServiceBase_hook_1.useProfileServiceBase; } });
//# sourceMappingURL=index.js.map